// removed by extract-text-webpack-plugin
module.exports = {"iconsBar":"_1pNp","opaque":"_2_uV","homeIcons":"_7Wk6","iconsGroup":"_2uSt","homeIcon":"_3b9e","menuIcon":"_1-ek","backIcon":"_3iTG","searchIcon":"_3e6X","bookYourStayBtn":"_3mjF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/smallheader/style.css
// module id = 173
// module chunks = 9